import React from "react";
import Button from "@mui/material/Button";

const CustomButton = ({ type = "button", onClick, children, className = "", variant = "contained", color = "primary", size = "medium" }) => {
    return (
        <Button
            type={type}
            onClick={onClick}
            variant={variant} // "contained", "outlined", or "text"
            color={color} // "primary", "secondary", "error", etc.
            size={size} // "small", "medium", or "large"
            className={className}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
